import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons';

const ChooseGroupModal = (({ groups, handleGroup, setShowModal }) => {

    const chooseGroup = (group) => {
        handleGroup(group);
        setShowModal(false);
    }

    return (
        <div className="modal-overlay">
            <div className="modal-box d-flex flex-column align-items-center">
                {groups?.map(group => (
                    <Button key={group.id} className="quiz-group-btn" onClick={() => chooseGroup(group)}>
                        {group.group_name} 
                    </Button>
                ))}
                {groups?.length === 0 &&
                <p>Create a group in your profile and invite some friends to join.</p>}
                <Button 
                    className="green-silver-btn mt-3"
                    onClick={() => setShowModal(false)}
                >
                    <FontAwesomeIcon icon={faRotateLeft} className="me-2"/>
                    Go Back
                </Button>
            </div>
        </div>
    );
});

export default ChooseGroupModal